import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Flex } from "rebass";
import { useHistory } from "react-router-dom";
import { getLocalizedString } from "../../utils";
import { Avatar } from "../../components/common/Avatar";

function Agent({ id, name, firstName, keyIndex }) {
  const navigate = useHistory();

  return (
    <Flex width={1} flexDirection="column" mb={3} key={keyIndex}>
      <Flex width={1} flexDirection={["column", "row", "row"]}>
        <Flex
          flexDirection={["row", "column", "column"]}
          backgroundColor={"#f5f5f5"}
          justifyContent={"space-between"}
          p={2}
          mb={[2, 0, 0]}
          mr={[0, 2, 2]}
        ></Flex>
        <Flex
          width={1}
          // justifyContent="space-evenly"
          alignItems="center"
          p={3}
          key="contents"
          backgroundColor="#f5f5f5"
        >
          <Avatar
            id="avatar"
            size={60}
            name={`${firstName}`}
            ml={[2, 2, 5]}
            mr={[4, 4, 5]}
          />
          <Flex flexDirection={["column", "row", "row"]} sx={{ flexGrow: 1 }}>
            <Box
              width={[1, "50%"]}
              flex="1 0 30%"
              height="100%"
              flexDirection="column"
              justifyContent="flex-start"
              sx={{
                alignContent: "center",
                flexDirection: "row",
              }}
            >
              <Box>
                <span style={{ fontSize: "0.9rem", marginRight: "4px" }}>
                  {getLocalizedString("Codice Agente")}
                </span>
                <span style={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                  {name}
                </span>
              </Box>
            </Box>

            <Box
              width={[1, "50%"]}
              height="100%"
              flexDirection="column"
              justifyContent="flex-start"
              sx={{
                alignContent: "center",
                flexDirection: "row",
              }}
            >
              <Box>
                <span style={{ fontSize: "0.9rem", marginRight: "4px" }}>
                  {getLocalizedString("Nome")}:
                </span>
                <span style={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                  {firstName}
                </span>
              </Box>
            </Box>
          </Flex>
        </Flex>
        <Flex
          width={[1, 300, 300]}
          style={{ backgroundColor: "#232323", minHeight: 100 }}
          p={3}
          flexDirection="column"
          alignItems="stretch"
          justifyContent="space-around"
          key="buttons"
          ml={[null, 2, 2]}
        >
          <Flex justifyContent="center" key="new">
            <Button
              variant="primary"
              sx={{
                fontFamily: "Open Sans",
                fontSize: "0.8em",
                fontWeigth: 800,
                color: "#000",
                width: "220px",
                background: "#fff",
                textTransform: "uppercase",
                "&:hover": {
                  backgroundColor: "#909090",
                  color: "white",
                },
              }}
              onClick={() => {
                localStorage.setItem("selectedAgent", id);
                navigate.push("/users/" + id);
              }}
            >
              {getLocalizedString("Seleziona agente")}
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}

Agent.propTypes = {
  name: PropTypes.string,
  keyIndex: PropTypes.string,
};
export default Agent;
